import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetCurrentTeam } from 'selectors/teams';

import { showModal } from 'actions/modal';

import IconSearch from 'icons/icon-search';

import './AppSearch.styles.css';

const AppSearch = ({ team, t }) => {
    const handleClick = () => {
        showModal('SEARCH_MODAL');
    }

    return (
        <React.Fragment>
            <div className="app-search-button" onClick={handleClick}>
                <IconSearch />

                {t('Search')} {team?.name}

            </div>
        </React.Fragment>
    )
}

const makeMapStateToProps = () => {
    const getCurrentTeam = makeGetCurrentTeam();

    return ({ teams }, ownProps) => ({
        team: getCurrentTeam(teams)
    });
}

export default connect(makeMapStateToProps)(withTranslation('common')(AppSearch));
